import { APP_NAME } from "./general"

const Text = {
    "message_inscription" : "Votre inscription s'est bien déroulée sur " + APP_NAME + ", Veuillez valider votre adresse email et ajouter les informations demandées pour votre profile (pays, villes, photo de profile ...)",
    "nombre_de_photos" : "Veuillez mettre 6 photos au maximum pour cette annonce.",
    "carte_ajoutee" : "Carte ajoutée avec succès",
}

export { Text }